export default __webpack_public_path__ + "static/media/insights-logo.1b85cd36.svg";